




























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  name: 'EmptyState'
})
export default class EmptyState extends Vue {
  @Prop({ default: 'mdi-inbox' }) icon!: string;
  @Prop({ default: 'No hay datos' }) title!: string;
  @Prop({ default: '' }) message!: string;
  @Prop({ default: '' }) actionText!: string;
  @Prop({ default: '' }) actionIcon!: string;
  @Prop({ default: 'grey' }) iconColor!: string;
  @Prop({ default: 'primary' }) actionColor!: string;
  @Prop({ default: 120 }) iconSize!: number;
}
